import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    loading: false,
    users: []
};

const getUsersSuccess = (state, action) => {
    const keys = Object.keys(action.payload.users); 
	
    const users = keys.map(i => { 
		let name = action.payload.users[i].data.username;
		if(action.payload.users[i].first_name || action.payload.users[i].last_name) {
			name = action.payload.users[i].first_name + " " + action.payload.users[i].last_name;
		}
		
		return {
			id: action.payload.users[i].data.id, 
			username: action.payload.users[i].data.username, 
			email: action.payload.users[i].email,
			name: name,
			role: action.payload.users[i].data.role,
            metadata: action.payload.users[i].data.metadata.fields || {},
			originalObject: action.payload.users[i]}
		}
	); 
    
    return updateObject(state, { users: users, loading: true });
}


const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.USER_GET_USERS_START: 
             return updateObject(state, { loading: true });     
        case actionTypes.USER_GET_USERS_SUCCESS: 
            return getUsersSuccess(state, action);
        case actionTypes.USER_GET_USERS_FAIL: 
             return updateObject(state, { loading: false });
        default: 
            return state;
    }
}

export default reducer;
